/** Deep link into /notifications/anatomy for one notification.
 *
 *  The anatomy page keeps its whole view in the URL, so a link only has to name
 *  the notification; everything else (channel, expanded subtrees, selected node)
 *  falls back to the page's own defaults.
 *
 *  `tenant` is passed when the caller knows it — not because the tree needs it
 *  (`nf` alone loads it), but because it scopes the page's notification picker.
 *  Arriving with the picker already narrowed to the right operator is the
 *  difference between "look at this one" and "look at this one, then the others
 *  next to it".
 *
 *  Follows the same undefined-vs-null discipline as the rest of this feature:
 *  `undefined` = the caller does not know the tenant (omit the param), `null` =
 *  known to be a system notification (`tour_operator IS NULL`).
 */
export function anatomyUrl(
  notificationId: number,
  tenant?: number | 'system' | null,
): string {
  const params = new URLSearchParams({ nf: String(notificationId) });
  if (tenant !== undefined) {
    params.set('tenant', tenant === null || tenant === 'system' ? 'system' : String(tenant));
  }
  return `/notifications/anatomy?${params.toString()}`;
}
